import { useEffect, useState } from "react";
import styles from "./rentrollreport.module.css";
import { Button, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { ArrowLeft, ArrowRight, Calendar, Download, Filter, Home, Search, User, X } from "react-feather";
import Helmet from "react-helmet";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { TableLoader } from "../../../components/LoaderC";
import Footer from "../../../components/Footer";
import Loader from "../../../components/Loader";
import axios from "axios";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import RentRollList from "./components/RentRollList";
import RentRollGraph from "./components/RentRollGraph";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { forwardRef } from "react";
import NumberFormat from "react-number-format";
import { toast } from "react-smart-toaster";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

const Initials = ({ fullName }) => {
    const parts = fullName.trim().split(" ");
    if (parts.length >= 2) {
        return (
            parts[0].charAt(0).toUpperCase() +
            parts[parts.length - 1].charAt(0).toUpperCase()
        );
    }
    return parts[0].substring(0, 2).toUpperCase();
}

const schema = yup.object().shape({
    min: yup.string().required("This field is Required"),
    max: yup.string().required("This field is Required"),
});

const MoneyField = forwardRef((props, ref) => {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={0} {...props} />);
});

const RentrollReport = () => {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [filterOpen, setFilterOpen] = useState(false);
    const [allRentrolls, setAllRentrolls] = useState([]);
    const [rentrollList, setRentrollList] = useState([]);
    const [selectedIds, setSelectedIds] = useState(null);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", rent: "", status: "", date: null });
    const [propertyList, setPropertyList] = useState([]);
    const [addCustomRent, setAddCustomRent] = useState(false);
    const [rentFilterOpen, setRentFilterOpen] = useState(false);
    const [rentFilterText, setRentFilterText] = useState('');
    const [openExportModal, setOpenExportModal] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(0);

    const { handleSubmit, control } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        async function getRentrolls() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/report/rent-roll", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllRentrolls(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        getRentrolls();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function getProperties() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch((error) => { });
        }
        getProperties();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let filterredDataTemp = allRentrolls;

        if (filterData?.searchKey !== "") {
            let inputVal = filterData?.searchKey;
            inputVal = inputVal.toLowerCase();
            filterredDataTemp = filterredDataTemp.filter((item) => item?.property_name?.toLowerCase().includes(inputVal) || item?.apt_no?.toLowerCase().includes(inputVal) || item?.bd_ba?.toLowerCase().includes(inputVal) || item?.tenant_name?.toLowerCase().includes(inputVal) || item?.size.toLowerCase().includes(inputVal) || item?.actual_rent.toString().toLowerCase().includes(inputVal) || item?.security_deposit.toString().toLowerCase().includes(inputVal));
        }

        if (filterData?.property !== "" && filterData?.property !== "all") {
            filterredDataTemp = filterredDataTemp.filter((i) => i.property_id === filterData.property);
        }

        if (filterData?.status !== "" && filterData?.status !== "all") {
            if (filterData?.status === "rented") {
                filterredDataTemp = filterredDataTemp.filter((i) => i.current_status === 2);
            }
            if (filterData?.status === "available") {
                filterredDataTemp = filterredDataTemp.filter((i) => i.current_status === 1);
            }
        }

        if (filterData?.rent !== "" && filterData?.rent !== "all" && filterData?.rent !== "custom") {
            let rentArr = filterData?.rent.split(",");
            let minRent = parseFloat(rentArr[0]);
            let maxRent = parseFloat(rentArr[1]);

            if (maxRent === 0) {
                filterredDataTemp = filterredDataTemp.filter((i) => i.rent >= minRent);
            } else {
                filterredDataTemp = filterredDataTemp.filter((i) => i.rent >= minRent && i.rent < maxRent);
            }
        }

        if (filterData?.date && Array.isArray(filterData?.date) && filterData?.date.length === 2) {
            const start = dayjs(filterData?.date[0]);
            const end = dayjs(filterData?.date[1]);

            filterredDataTemp = filterredDataTemp.filter((i) => {
                if (!i?.movein_date) return false;

                const moveinDate = dayjs(i.movein_date);

                return moveinDate.isBetween(start, end, null, "[]");
            });
        }

        setRentrollList(filterredDataTemp);
    }, [allRentrolls, filterData]);

    useEffect(() => {
        let aptIds = rentrollList?.map(i => {
            return i?.id;
        });

        setSelectedIds(aptIds);
    }, [rentrollList]);

    const exportTenants = async () => {
        try {
            if (selectedProperty === '' || selectedProperty === 0) {
                toast.error('Please select property.');
                return false;
            }
            setLoading(true);
            setOpenExportModal(false);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const response = await axios.get(
                process.env.REACT_APP_USER_API_URL + "v1/report/rent-roll-export/" + selectedProperty,
                {
                    responseType: "blob", // 🔥 VERY IMPORTANT
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setLoading(false);

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "RentrollReport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url)

        } catch (error) {
            setLoading(false);
            console.error("Export failed", error);
        }
    }

    const onSubmitRentFilter = (data) => {
        setAddCustomRent(false);
        setRentFilterOpen(false);

        setRentFilterText('$' + data.min + ' - $' + data.max);

        setFilterData(prev => {
            return { ...prev, rent: parseInt(data.min.toString().replace(/,/g, ""), 10) + ',' + parseInt(data.max.toString().replace(/,/g, ""), 10) };
        });
    }

    useEffect(() => {
        if (filterData?.rent === "custom") {
            setRentFilterOpen(true);
        }
    }, [filterData?.rent]);

    return (<>
        <Helmet title="Rentroll Reports" />
        {loading && <Loader />}
        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Rent Roll Report</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Report</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Rent Roll Report</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    <div className="control-pane">
                        {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                        <div className={`${styles.Row}`}>

                            {!contentLoading && <>

                                <div className={`${styles.SearchFilterSec}`}>
                                    <div className={`${styles.SearchCon}`}>
                                        <div className={`${styles.SearchConSec}`}>
                                            <Search />
                                            <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); }} />
                                        </div>
                                    </div>

                                    <div className={`${styles.FilterSec}`}>
                                        <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                                            <p className={`${styles.FilterTitle}`}>
                                                Filters
                                                <span onClick={(e) => setFilterOpen(false)}>
                                                    <ArrowRight />
                                                </span>
                                            </p>
                                            <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Property</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Property"
                                                        value={filterData?.property}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, property: e.target.value }; });
                                                        }}
                                                    >
                                                        <MenuItem value={'all'}>Any</MenuItem>
                                                        {propertyList?.map((i) => {
                                                            return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className={`${styles.FilterCard}`}>
                                                <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                                                    <DateRangePicker
                                                        format={"MM/dd/yy"}
                                                        placeholder={"Filter by date"}
                                                        placement={"bottomEnd"}
                                                        caretAs={Calendar}
                                                        showOneCalendar
                                                        value={filterData.date && Array.isArray(filterData.date) ? filterData.date : null}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, date: e }; });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Rent Amount Range</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Rent Amount Range"
                                                        value={filterData?.rent}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, rent: e.target.value }; });
                                                            setRentFilterOpen(true);

                                                            if (e.target.value === 'custom') {
                                                                setAddCustomRent(true);
                                                            } else {
                                                                setAddCustomRent(false);
                                                            }
                                                        }}
                                                        open={rentFilterOpen}
                                                        onClose={(e) => { setRentFilterOpen(false); }}
                                                        onOpen={(e) => setRentFilterOpen(true)}
                                                        renderValue={(selected) => {
                                                            if (!selected) return "";
                                                            if (selected === "all")
                                                                return "All Rent";
                                                            else if (selected === "0,300")
                                                                return "< $300";
                                                            else if (selected === "300,600")
                                                                return "$300 - $600";
                                                            else if (selected === "600,900")
                                                                return "$600 - $900";
                                                            else if (selected === "900,1200")
                                                                return "$900 - $1,200";
                                                            else if (selected === "1200,0")
                                                                return "> $1,200";
                                                            else if (selected === "custom")
                                                                return "Custom";
                                                            else if (rentFilterText !== '')
                                                                return rentFilterText;
                                                            else
                                                                return "";

                                                        }}
                                                    >
                                                        <MenuItem value="all">All Rent</MenuItem>
                                                        <MenuItem value="0,300">&lt; $300</MenuItem>
                                                        <MenuItem value="300,600">$300 - $600</MenuItem>
                                                        <MenuItem value="600,900">$600 - $900</MenuItem>
                                                        <MenuItem value="900,1200">$900 - $1,200</MenuItem>
                                                        <MenuItem value="1200,0">&gt; $1,200</MenuItem>
                                                        <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomRent(true); }}>Custom Range Filter</MenuItem>
                                                        {addCustomRent && (<div className={`${styles.CustomFilterSec}`}>
                                                            <form onSubmit={handleSubmit(onSubmitRentFilter)}>
                                                                <div className={`${styles.CustomFilterSecRow}`}>
                                                                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                                                                        <Controller
                                                                            name={`min`}
                                                                            control={control}
                                                                            render={(field) => (<MoneyField
                                                                                {...field}
                                                                                id="outlined-basic"
                                                                                label="Min Rent"
                                                                                variant="outlined"
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    field.onChange(e);
                                                                                }}
                                                                            />)}
                                                                        />
                                                                    </div>
                                                                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                                                                        <Controller
                                                                            name={`max`}
                                                                            control={control}
                                                                            render={(field) => (<MoneyField
                                                                                {...field}
                                                                                id="outlined-basic"
                                                                                label="Max Rent"
                                                                                variant="outlined"
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    field.onChange(e);
                                                                                }}
                                                                            />)}
                                                                        />
                                                                    </div>
                                                                    <div className={`${styles.CustomFiletrBUsec}`}>
                                                                        <Button onClick={(e) => { setAddCustomRent(false); setFilterData((prev) => { return { ...prev, rent: "" }; }); setRentFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                                                                        <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>)}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Status"
                                                        value={filterData?.status}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, status: e.target.value }; });
                                                        }}
                                                    >
                                                        <MenuItem value="all">All</MenuItem>
                                                        <MenuItem value="rented">Rented</MenuItem>
                                                        <MenuItem value="available">Available</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                                            <Filter />
                                        </Link>
                                        <Link className={`${styles.AddNoteBu}`} onClick={(e) => setOpenExportModal(true)}>
                                            <Download /> <span>Export Report</span>
                                        </Link>
                                    </div>
                                </div>

                                <div className={`${styles.IncomeListingBody}`}>
                                    <div className={`${styles.IncomeListSec}`}>
                                        <RentRollList rentrollList={rentrollList} />
                                    </div>
                                    <div className={`${styles.IncomeGraphSec}`}>
                                        <RentRollGraph selectedIds={selectedIds} />
                                    </div>
                                </div>

                                <div className={`${styles.ListMobileView}`}>
                                    {rentrollList?.map((item, index) => {
                                        return <div key={index} className={`${styles.MaintenanceReqCard}`}>
                                            <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                                                {item?.current_tenant ? (<>
                                                    <div className={`${styles.ProNameIMG}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.current_tenant) { redirect.push("/people/tenants/details/" + item.current_tenant); } }}>
                                                        {item?.tenant_image !== "" ? (<img src={item?.tenant_image} alt="" />) : (<p><Initials fullName={item?.tenant_name} /></p>)}
                                                    </div>
                                                </>) : <div className={`${styles.ProNameIMG}`}>
                                                    <User />
                                                </div>}
                                                <div>
                                                    {item?.current_tenant ? <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.current_tenant) { redirect.push("/people/tenants/details/" + item.current_tenant); } }}>
                                                        {item?.tenant_name}
                                                    </p> : <p className={`${styles.Name}`}>-</p>}
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_name} - {item?.apt_no}</p>
                                                </div>
                                            </div>
                                            <div className={`${styles.SecondSec}`}>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>Rent: <span>{item?.actual_rent !== '' ? '$' + item?.actual_rent : '-'}</span></p>
                                                    <p className={`${styles.Name}`}>Sec. Deposit: <span>{item?.security_deposit !== '' ? '$' + item?.security_deposit : '-'}</span></p>
                                                </div>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>BD/BA: <span>{item?.bd_ba}</span></p>
                                                    <p className={`${styles.Name}`}>Sqft: <span>{item?.size}</span></p>
                                                </div>
                                            </div>
                                            <div className={`${styles.ThirdSec}`}>
                                                <div className={`${styles.StatusBadgeSecMobile}`}>
                                                    {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Confirm}`}>Rented</span>}
                                                    {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.NotVerified}`}>Available</span>}
                                                    {item?.current_status !== 1 && item?.current_status !== 2 && <span className={`${styles.StatusBadge} ${styles.Failed}`}>Not Available</span>}
                                                </div>
                                                <p className={`${styles.Name}`}>
                                                    Move-In<span>{item?.movein_date !== '' ? dayjs(item?.movein_date).format('MM-DD-YYYY') : '-'}</span>
                                                </p>
                                            </div>
                                        </div>
                                    })}
                                </div>

                            </>}

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={openExportModal}
            fullWidth
            maxWidth="xs"
            onClose={(e) => setOpenExportModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp CustomWidthPopUs MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenExportModal(false)}><ArrowLeft /></button>
                <span>Export Rent Roll Report</span>
                <button onClick={(e) => setOpenExportModal(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className={`${styles.AddprospectFirstStepForm}`}>
                    <p className={`${styles.AddprospectFirstStepFormTitle}`}> Please select a property before exporting the Rent Roll Report.</p>
                    <p className={`${styles.AddprospectFirstStepFormTitleTwo}`}>The report will include rented and available units only. Tenant, lease, and rent details for the selected property will be included in the exported Excel file.</p>
                    <div className={`${styles.HalfStepFormRow}`}>
                        <div className={`${styles.HalfStepFormFullSec} FormGroup`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Select Property*</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select property*"
                                    onChange={(e) => {
                                        setSelectedProperty(e.target.value);
                                    }}
                                >
                                    {propertyList?.map((i) => {
                                        return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className={`${styles.ButtonAction}`}>
                        <Button onClick={(e) => setOpenExportModal(false)} className="CancelPopupBU">Cancel</Button>
                        <Button className="SubmitPopupBU" onClick={(e) => exportTenants()}>Export</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>

        <Footer />
    </>);
}

export default withAuthenticationRequired(RentrollReport, {
    onRedirecting: () => <Loader />,
});